import { useState } from 'react';
import { Menu, X, Terminal } from 'lucide-react';
import { NAV_LINKS, CONTACT_INFO } from '../data/content';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Helper to generate dynamic ticket ID and update the mailto link
  const handleTicketClick = (e) => {
    const ticketId = Math.floor(1000 + Math.random() * 9000);
    const subject = encodeURIComponent(`Support Inquiry - Ticket #${ticketId}`);
    
    // Update the link href dynamically upon click
    e.currentTarget.href = `mailto:${CONTACT_INFO.email}?subject=${subject}`;
  };

  return (
    <nav className="fixed w-full z-50 bg-[#0A192F]/90 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex items-center font-black text-white text-xl tracking-tighter">
          <Terminal className="text-blue-500 mr-2" /> Infra<span className="text-blue-500">Tier</span>
        </div>
        
        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map(link => (
            <a key={link.name} href={link.href} className="text-sm font-medium hover:text-blue-400 transition">{link.name}</a>
          ))}
          <a 
            href={`mailto:${CONTACT_INFO.email}`}
            onClick={handleTicketClick}
            className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg text-sm font-bold transition"
          >
            OPEN A TICKET
          </a>
        </div>

        <button className="md:hidden text-white" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X /> : <Menu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-[#0A192F] border-b border-slate-800 p-6 flex flex-col gap-4">
          {NAV_LINKS.map(link => (
            <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="text-lg font-medium">{link.name}</a>
          ))}
          <a 
            href={`mailto:${CONTACT_INFO.email}`}
            onClick={handleTicketClick}
            className="bg-blue-600 text-center py-3 rounded-lg font-bold"
          >
            OPEN A TICKET
          </a>
        </div>
      )}
    </nav>
  );
};